module.exports = __webpack_public_path__ + "console/img/顺丰.97154c32.jpg";